import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const routerOptions = [
  { path: "/", component: "HomeView", name: "Home"},
  { path: "/login", component: "LoginView", name: "Login"},
  { path: "/logout", component: "LogoutView", name: "Logout"},
  { path: "/signup", component: "SignupView", name: "Signup"},
  { path: "/password_reset", component: "PasswordResetView", name: "Password reset"},
  { path: "/password/reset/confirm/:uid/:token", component: "PasswordResetConfirmView", name: "Password reset confirm"},
  { path: "/confirmation/:token", component: "SignupConfirmationView", name: "Signup confirmation"},
  { path: "/my_events", component: "MyEventsView", name: "My events"},
  { path: "/edit_event/:event_slug", component: "EditEventView", name: "Event edit"},
  { path: "/add_event", component: "EventFormView", name: "Add new event"},
  { path: "/my_profile", component: "MyProfileView", name: "My profile"},
  { path: "/event/details/:event_slug", component: "EventDetailsView", name: "Event detials"},
  { path: "/my_invitations", component: "MyInvitationsView", name: "My invitations"},
  { path: "/miscellaneous", component: "MiscellaneousView", name: "Miscellaneous"},
  { path: "/my_documents", component: "MyDocumentsView", name: "My documents"},
  { path: "/notifications", component: "NotificationsView", name: "Notifications"},
  { path: "/tests", component: "Tests" },
  { path: "/database", component: "DatabaseView" },
];

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/views/${route.component}.vue`)
  };
});

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: '/',
  routes
});

router.beforeEach(async (to, from, next) => {
  switch (to.matched[0].path) {
    case "/signup":
    case "/resetpassword/:token":
    case "/password_reset":
    case "/password/reset/confirm/:uid/:token":
    case "/forgotpassword":
    case "/login":
    case "/confirmation/:token":
    case "*":
      next();
      break;
    default:
      if (store.state.profiles.ownProfile) {
        next()
      }
      else if (!store.state.profiles.ownProfile && sessionStorage.getItem("auth_token")) {
        const response = await store.dispatch('getOwnProfile')
        if (response) {
          next()
        }
      }
      else if (!store.state.profiles.ownProfile && !sessionStorage.getItem("auth_token")) {
        next("/login")
      }
  }
  if (to !== from) {
    store.commit("PUSH_TO_HISTORY", to.path);
    next();
  }
});

export default router;
